import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"museum-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M11.9999 3C10.5215 3 9.14647 3.44251 8 4.2023V21H16L16 4.20241C14.8535 3.44255 13.4784 3 11.9999 3Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M2 9C5.31371 9 8 11.6863 8 15V21H2V9Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M22 9C18.6863 9 16 11.6863 16 15V21H22V9Z"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 21V16M16 21V15C16 11.6863 18.6863 9 22 9V21H16ZM8 21V15C8 11.6863 5.31371 9 2 9V21H8ZM12 7.99805H12.0039V8.00195H12V7.99805Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 4.7V21H16L16 4.70011M7.00195 4.99804C7.3101 4.7047 7.64403 4.43821 8 4.2023C9.14647 3.44251 10.5215 3 11.9999 3C13.4784 3 14.8535 3.44255 16 4.20241C16.3567 4.43882 16.6913 4.70593 16.9999 4.99999","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Museum1 = Vue.extend<IconProps>({
  name: 'Museum1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'museum-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Museum1;
